import CryptoJS from "crypto-js";
import { SECRET_KEY } from "./Constants";

export const dataEncrpt = (value) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
  } catch (error) {
    console.log("🚀 ~ file: data-encrypt.js:9 ~ dataEncrpt ~ error:", error);
  }
};

export const dataDecrypt = (value) => {
  try {
    const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.log("🚀 ~ file: data-decrypt.js:9 ~ dataDecrypt ~ error:", error);
  }
};
